const TOKEN_KEY = 'fancap_auth_token';
const USER_KEY = 'fancap_user_info';

/**
 * 存储认证token到localStorage
 */
export function setStoredToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch (error) {
    console.error('Failed to store token:', error);
  }
}

/**
 * 从localStorage获取认证token
 */
export function getStoredToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (error) {
    console.error('Failed to get stored token:', error);
    return null;
  }
}

/**
 * 从localStorage移除认证token
 */
export function removeStoredToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  } catch (error) {
    console.error('Failed to remove stored token:', error);
  }
}

/**
 * 存储用户信息到localStorage
 */
export function setStoredUser(user: any): void {
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } catch (error) {
    console.error('Failed to store user info:', error);
  }
}

/**
 * 从localStorage获取用户信息
 */
export function getStoredUser(): any | null {
  try {
    const userStr = localStorage.getItem(USER_KEY);
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    console.error('Failed to get stored user info:', error);
    return null;
  }
}

/**
 * 检查是否有存储的认证信息
 */
export function hasStoredAuth(): boolean {
  return !!getStoredToken();
}

/**
 * 清除所有存储的认证信息
 */
export function clearStoredAuth(): void {
  removeStoredToken();
}